// WebViewProvider
import React, { useState, PropsWithChildren, useEffect, startTransition } from "react";
import WebViewContext, { IWebViewContext } from "./WebViewContext";
import isWebView from "@src/lib/WebView/isWebView";

// Utility function to detect if the app is running in a webview

const WebViewProvider: React.FC<PropsWithChildren> = (props) => {
  const { children } = props;
  const [isInWebView, setInWebView] = useState<boolean>(false);
  // useEffect (pas useLayoutEffect) + startTransition : mettre à jour le contexte
  // *après* l’hydratation des blocs <Suspense> (lazy) dans DefaultLayout — sinon
  // React #421 « This Suspense boundary received an update before it finished
  // hydrating » (plusieurs instances possibles, une par frontière enfant).
  useEffect(() => {
    const inView = isWebView();
    startTransition(() => {
      setInWebView(inView);
    });
  }, []);

  const contextValue: IWebViewContext = {
    isWebView: isInWebView,
  };

  return (
    <WebViewContext.Provider value={contextValue}>
      {children}
    </WebViewContext.Provider>
  );
};

export default WebViewProvider;
